import Tippy from "@tippyjs/react";
import { useState, useEffect, useCallback } from "react";
import Percentile from "./Percentile";

function Scale(props) {
    const { name, percentile, colour, description, band_description, colourPalette, scaleIndex } = props;

    const [percentileBackgroundColour, setPercentileBackgroundColour] = useState("bg-blue-gray-300");
    const [textColour, setTextColour] = useState("text-blue-gray-50");

    const handleSetColour = useCallback(async () => {
        setTimeout(() => {
            setPercentileBackgroundColour(
                colourPalette[scaleIndex]
                    ? `bg-${colour}-${colourPalette[scaleIndex]}`
                    : `bg-${colour}-${colourPalette[colourPalette.length - 1]}`
            );
            setTextColour(
                colourPalette[scaleIndex]
                    ? `text-${colour}-${colourPalette[scaleIndex]}`
                    : `text-${colour}-${colourPalette[colourPalette.length - 1]}`
            );
        }, 100);
    }, [colour, colourPalette, scaleIndex]);

    useEffect(() => {
        handleSetColour(percentile);
    }, [handleSetColour, percentile]);

    return (
        <div>
            {description ? (
                <>
                    <Tippy
                        content={description}
                        className={"p-2 shadow rounded-md bg-secondary-500 text-white text-sm"}
                        arrow={false}
                        animation={"shift-away-subtle"}
                    >
                        <h2
                            className={
                                "cursor-help transition transition-color duration-4000 ease-in-out font-medium text-lg " +
                                textColour
                            }
                        >
                            {name}
                        </h2>
                    </Tippy>

                    <p className="text-blue-gray-500 my-3 text-md">{description}</p>
                </>
            ) : (
                <h2
                    className={
                        "transition transition-color duration-4000 ease-in-out font-medium text-lg " + textColour
                    }
                >
                    {name}
                </h2>
            )}

            <div className="mt-3 grid md:grid-cols-12 grid-flow-row gap-4">
                <div className={"col-span-2 flex items-center jusitfy-center"}>
                    <Percentile
                        size={"large"}
                        percentile={percentile}
                        colour={colour}
                        colourPalette={colourPalette}
                        scaleIndex={scaleIndex}
                    />
                </div>

                <div className={"col-span-10"}>
                    <div
                        className={
                            "transition transition-color duration-4000 p-3 rounded-xl shadow-sm text-white " +
                            percentileBackgroundColour
                        }
                    >
                        {band_description && band_description}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Scale;
